var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Config from 'react-native-config';
const APPLE_SDK_SRC = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
function loadAppleSdk() {
    const w = window;
    if (w.AppleID) {
        return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[src="${APPLE_SDK_SRC}"]`);
        if (existing) {
            existing.addEventListener('load', () => resolve());
            existing.addEventListener('error', () => reject(new Error('Apple SDK load failed')));
            return;
        }
        const script = document.createElement('script');
        script.src = APPLE_SDK_SRC;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Apple SDK load failed'));
        document.head.appendChild(script);
    });
}
export function appleWebSignIn() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        const serviceId = ((_a = Config.APPLE_WEB_SERVICE_ID) !== null && _a !== void 0 ? _a : '').trim();
        if (!serviceId) {
            throw new Error('APPLE_WEB_SERVICE_ID is not configured');
        }
        yield loadAppleSdk();
        const AppleID = window.AppleID;
        AppleID.auth.init({
            clientId: serviceId,
            scope: 'name email',
            redirectURI: `${window.location.origin}/oauth/apple`,
            usePopup: true,
        });
        const data = yield AppleID.auth.signIn();
        return {
            authorizationCode: (_c = (_b = data === null || data === void 0 ? void 0 : data.authorization) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : '',
            identityToken: (_e = (_d = data === null || data === void 0 ? void 0 : data.authorization) === null || _d === void 0 ? void 0 : _d.id_token) !== null && _e !== void 0 ? _e : '',
        };
    });
}
